/**
 * Made.bb Landing Page — Epic 3
 *
 * MADE-255: Feature flag scaffold (shell committed 3b4c9f8)
 * MADE-256: HeroSection         — purple gradient, headline, two CTAs, SVG placeholder
 * MADE-257: ServicesSection     — Custom 3D Prints + Commercial/Production cards
 * MADE-258: PartnerSection      — static placeholder, no form or backend
 * MADE-259: StoryTeaserSection  — 2 sentences + "Our story →" → /shop/about
 * MADE-260: LandingNav + TrustBar + LandingFooter — trust signals, Staff Login in footer
 *
 * Enabled via VITE_FEATURE_NEW_LANDING=true (Railway staging env).
 * ComingSoon remains the default when the flag is off. Do NOT modify ComingSoon.tsx.
 */

import { Box } from '@mui/material';
import { LandingNav } from './landing/LandingNav';
import { HeroSection } from './landing/HeroSection';
import { ServicesSection } from './landing/ServicesSection';
import { PartnerSection } from './landing/PartnerSection';
import { StoryTeaserSection } from './landing/StoryTeaserSection';
import { TrustBar } from './landing/TrustBar';
import { LandingFooter } from './landing/LandingFooter';

const LandingPage = () => {
  return (
    <Box
      data-testid="landing-page"
      sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      {/* MADE-260: Minimal landing nav — Shop, Custom Order, About. No Staff Login. */}
      <LandingNav />

      {/* MADE-256: Hero — purple gradient (#667eea → #764ba2), restricted to this section */}
      <HeroSection />

      {/* MADE-257: Services — Custom 3D Prints + Commercial/Production (no product cards) */}
      <ServicesSection />

      {/* MADE-258: Partner Program — static placeholder, no functionality */}
      <PartnerSection />

      {/* MADE-259: Story teaser — 2 sentences + "Our story →" → /shop/about */}
      <StoryTeaserSection />

      {/* MADE-260: Trust bar — Established 1992 · Made in Barbados · Marine-grade · DHL */}
      <TrustBar />

      {/* MADE-260: Footer — Staff Login lives here, not in the primary nav */}
      <LandingFooter />
    </Box>
  );
};

export default LandingPage;
